import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  loading: false,
  error: null,
  showLogin: false,
  cartCount: 0,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    getUser(state) {
      state.loading = true;
    },
    getUserSuccess(state, action) {
      state.loading = false;
      state.user = action.payload;
      state.error = null;
    },
    getUserFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    updateUser(state, action) {
      state.loading = true;
    },
    updateUserSuccess(state, action) {
      state.loading = false;
      state.user = action.payload;
      state.error = null;
    },
    updateUserFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    handleLoginPopup(state, action) {
      state.showLogin = action.payload;
    },
    hanleChangeCartCount(state, action) {
      state.cartCount = action.payload;
    },
    handleChangeCartCount(state, action) {
      state.cartCount = state.cartCount + action.payload;
    },
    emptyCartCount(state, action) {
      state.cartCount = 0;
    },
  },
});

export const {
  emptyCartCount,
  handleChangeCartCount,
  getUser,
  getUserSuccess,
  getUserFailure,
  updateUser,
  updateUserSuccess,
  updateUserFailure,
  handleLoginPopup,
  hanleChangeCartCount,
} = userSlice.actions;

export default userSlice.reducer;
